/* ==========================================================================
   PLUG PRO — feature engine (vanilla JS, no dependencies)
   Every module is defensive: if its markup isn't on the page, it no-ops.
   ========================================================================== */
(function () {
  'use strict';

  var PP = (window.PlugPro = window.PlugPro || {});
  var cfg = window.plugProSettings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function store(key, val) {
    try {
      if (val === undefined) {
        var raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      }
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { /* private mode / blocked storage */ }
    return null;
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    var fmt = (cfg.moneyFormat || '${{amount}}');
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function trapFocus(container) {
    var focusables = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return function () {};
    var first = focusables[0], last = focusables[focusables.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    first.focus();
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------------------------------------------------------------- Modal */
  PP.openModal = function (modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal._release = trapFocus(modal);
  };
  PP.closeModal = function (modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (modal._release) modal._release();
  };

  function wireModalDismiss(modal) {
    if (!modal) return;
    on(modal, 'click', function (e) {
      if (e.target === modal || e.target.closest('[data-pp-close]')) PP.closeModal(modal);
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) PP.closeModal(modal);
    });
  }

  /* ------------------------------------------------------ Back to top */
  function initBackToTop() {
    var btn = $('[data-pp-backtotop]');
    if (!btn) return;
    var threshold = 500;
    function update() { btn.classList.toggle('is-visible', window.scrollY > threshold); }
    on(window, 'scroll', update, { passive: true });
    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    update();
  }

  /* ------------------------------------------------------ Age verifier */
  function initAgeGate() {
    var gate = $('[data-pp-agegate]');
    if (!gate) return;
    var KEY = 'pp_age_ok';
    if (store(KEY)) return;
    PP.openModal(gate);
    on($('[data-pp-age-confirm]', gate), 'click', function () {
      store(KEY, { ok: true, at: Date.now() });
      PP.closeModal(gate);
    });
    on($('[data-pp-age-deny]', gate), 'click', function () {
      var url = gate.getAttribute('data-deny-url') || 'https://www.google.com';
      window.location.href = url;
    });
  }

  /* ------------------------------------------------------ Promo popup */
  function initPromoPopup() {
    var popup = $('[data-pp-popup]');
    if (!popup) return;
    var KEY = 'pp_popup_seen';
    var days = parseInt(popup.getAttribute('data-frequency'), 10) || 7;
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 5;
    var seen = store(KEY);
    if (seen && seen.at && (Date.now() - seen.at) < days * 864e5) return;
    wireModalDismiss(popup);
    setTimeout(function () {
      if ($('[data-pp-agegate].is-open')) return; // never stack over the age gate
      PP.openModal(popup);
      store(KEY, { at: Date.now() });
    }, delay * 1000);
  }

  /* ------------------------------------------------- Countdown timers */
  function initCountdowns() {
    var nodes = $$('[data-pp-countdown]');
    if (!nodes.length) return;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      nodes.forEach(function (node) {
        var end = parseInt(node.getAttribute('data-end'), 10);
        if (!end) return;
        var diff = end - Date.now();
        if (diff <= 0) {
          if (node.getAttribute('data-on-end') === 'hide') {
            var sec = node.closest('.shopify-section');
            if (sec) sec.style.display = 'none';
          } else {
            node.innerHTML = '<span class="pp-countdown__expired">' + (node.getAttribute('data-expired-text') || 'Offer ended') + '</span>';
          }
          return;
        }
        var d = Math.floor(diff / 864e5);
        var h = Math.floor((diff % 864e5) / 36e5);
        var m = Math.floor((diff % 36e5) / 6e4);
        var s = Math.floor((diff % 6e4) / 1000);
        var map = { days: d, hours: h, minutes: m, seconds: s };
        $$('[data-unit]', node).forEach(function (u) {
          var k = u.getAttribute('data-unit');
          var target = $('.pp-countdown__num', u);
          if (target) target.textContent = k === 'days' ? String(map[k]) : pad(map[k]);
        });
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* --------------------------------------------------- Before / after */
  function initBeforeAfter() {
    $$('[data-pp-beforeafter]').forEach(function (el) {
      var after = $('.pp-ba__after', el);
      var handle = $('.pp-ba__handle', el);
      if (!after || !handle) return;
      var start = parseFloat(el.getAttribute('data-start')) || 50;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        after.style.width = pct + '%';
        handle.style.left = pct + '%';
        el.setAttribute('aria-valuenow', Math.round(pct));
      }
      function fromEvent(e) {
        var rect = el.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        setPos((x / rect.width) * 100);
      }
      var dragging = false;
      on(el, 'mousedown', function (e) { dragging = true; fromEvent(e); e.preventDefault(); });
      on(window, 'mousemove', function (e) { if (dragging) fromEvent(e); });
      on(window, 'mouseup', function () { dragging = false; });
      on(el, 'touchstart', function (e) { dragging = true; fromEvent(e); }, { passive: true });
      on(el, 'touchmove', function (e) { if (dragging) fromEvent(e); }, { passive: true });
      on(el, 'touchend', function () { dragging = false; });
      on(el, 'keydown', function (e) {
        var cur = parseFloat(el.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft') { setPos(cur - 4); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(cur + 4); e.preventDefault(); }
      });
      setPos(start);
    });
  }

  /* -------------------------------------------------- Image hotspots */
  function initHotspots() {
    var spots = $$('.pp-hotspot');
    if (!spots.length) return;
    spots.forEach(function (spot) {
      var dot = $('.pp-hotspot__dot', spot);
      on(dot, 'click', function (e) {
        e.stopPropagation();
        var wasOpen = spot.classList.contains('is-open');
        spots.forEach(function (s) { s.classList.remove('is-open'); });
        spot.classList.toggle('is-open', !wasOpen);
        dot.setAttribute('aria-expanded', String(!wasOpen));
      });
    });
    on(document, 'click', function () {
      spots.forEach(function (s) { s.classList.remove('is-open'); });
    });
  }

  /* ------------------------------------------------------ Product tabs */
  function initTabs() {
    $$('[data-pp-tabs]').forEach(function (wrap) {
      var btns = $$('.pp-tabs__btn', wrap);
      var panels = $$('.pp-tabs__panel', wrap);
      if (!btns.length) return;
      function activate(i) {
        btns.forEach(function (b, idx) {
          b.setAttribute('aria-selected', String(idx === i));
          b.setAttribute('tabindex', idx === i ? '0' : '-1');
        });
        panels.forEach(function (p, idx) { p.classList.toggle('is-active', idx === i); });
      }
      btns.forEach(function (b, i) {
        on(b, 'click', function () { activate(i); });
        on(b, 'keydown', function (e) {
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          var target = (next + btns.length) % btns.length;
          btns[target].focus();
          activate(target);
        });
      });
      activate(0);
    });
  }

  /* ------------------------------------------------------- Size chart */
  function initSizeChart() {
    var modal = $('[data-pp-sizechart-modal]');
    if (!modal) return;
    wireModalDismiss(modal);
    $$('[data-pp-sizechart-open]').forEach(function (btn) {
      on(btn, 'click', function () { PP.openModal(modal); });
    });
  }

  /* ---------------------------------------------- Sticky add to cart */
  function initStickyAtc() {
    var bar = $('[data-pp-sticky-atc]');
    if (!bar) return;
    var form = $('product-form form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
    var anchor = $('.product-form__buttons') || form;
    if (!anchor) return;
    document.body.classList.add('pp-has-sticky-atc');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -100% 0px' });
    io.observe(anchor);

    on($('[data-pp-sticky-submit]', bar), 'click', function () {
      var submit = $('[type="submit"]', form);
      if (submit) submit.click();
    });
  }

  /* --------------------------------------------------- Recently viewed */
  function recordRecentlyViewed() {
    if (!cfg.productHandle) return;
    var KEY = 'pp_recently_viewed';
    var list = store(KEY) || [];
    list = list.filter(function (h) { return h !== cfg.productHandle; });
    list.unshift(cfg.productHandle);
    store(KEY, list.slice(0, 12));
  }

  function initRecentlyViewed() {
    var wrap = $('[data-pp-recently-viewed]');
    if (!wrap) return;
    var KEY = 'pp_recently_viewed';
    var list = (store(KEY) || []).filter(function (h) { return h !== cfg.productHandle; });
    var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 4;
    list = list.slice(0, limit);
    if (!list.length) return;

    var grid = $('[data-pp-recent-grid]', wrap);
    var done = 0;
    list.forEach(function (handle) {
      fetch(window.Shopify.routes.root + 'products/' + handle + '?section_id=pp-recently-viewed-card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var card = tmp.querySelector('[data-pp-card]');
            if (card && grid) grid.appendChild(card);
          }
        })
        .catch(function () {})
        .finally(function () {
          done++;
          if (done === list.length && grid && grid.children.length) wrap.hidden = false;
        });
    });
  }

  /* -------------------------------------------------------- Quick view */
  function initQuickView() {
    var modal = $('[data-pp-quickview-modal]');
    if (!modal) return;
    wireModalDismiss(modal);
    var body = $('[data-pp-quickview-body]', modal);

    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-pp-quickview]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-pp-quickview');
      if (!handle || !body) return;
      body.innerHTML = '<div class="pp-quickview__loading">' + (cfg.strings && cfg.strings.loading || 'Loading…') + '</div>';
      PP.openModal(modal);
      fetch(window.Shopify.routes.root + 'products/' + handle + '?section_id=pp-quick-view')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) throw new Error('not found');
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-pp-quickview-content]') || tmp;
          body.innerHTML = '';
          body.appendChild(inner);
        })
        .catch(function () {
          body.innerHTML = '<p>' + (cfg.strings && cfg.strings.qvError || 'Could not load this product.') + '</p>';
        });
    });
  }

  /* -------------------------------------------- Infinite scroll / more */
  function initLoadMore() {
    var wrap = $('[data-pp-loadmore]');
    if (!wrap) return;
    var mode = wrap.getAttribute('data-mode') || 'button';
    var btn = $('[data-pp-loadmore-btn]', wrap);
    var grid = $('#product-grid') || $('[data-pp-grid]');
    var loading = false;

    function nextUrl() { return wrap.getAttribute('data-next'); }

    function load() {
      var url = nextUrl();
      if (!url || loading) return;
      loading = true;
      wrap.classList.add('is-loading');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newGrid = tmp.querySelector('#product-grid') || tmp.querySelector('[data-pp-grid]');
          if (newGrid && grid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (li) { grid.appendChild(li); });
          }
          var newWrap = tmp.querySelector('[data-pp-loadmore]');
          var next = newWrap ? newWrap.getAttribute('data-next') : null;
          if (next) { wrap.setAttribute('data-next', next); }
          else { wrap.removeAttribute('data-next'); wrap.style.display = 'none'; }
        })
        .catch(function () {})
        .finally(function () { loading = false; wrap.classList.remove('is-loading'); });
    }

    if (btn) on(btn, 'click', load);
    if (mode === 'infinite') {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) load();
      }, { rootMargin: '400px' });
      io.observe(wrap);
    }
  }

  /* ---------------------------------------------------------- Gift wrap */
  function initGiftWrap() {
    var box = $('[data-pp-giftwrap]');
    if (!box) return;
    var checkbox = $('input[type="checkbox"]', box);
    var noteField = $('[data-pp-giftwrap-note]', box);
    if (noteField) {
      var sync = function () { noteField.hidden = !checkbox.checked; };
      on(checkbox, 'change', sync);
      sync();
    }
  }

  /* ------------------------------------------------------- Stock meter */
  function initStockMeters() {
    $$('[data-pp-stock]').forEach(function (el) {
      var qty = parseInt(el.getAttribute('data-qty'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10) || 20;
      var fill = $('.pp-stock__fill', el);
      if (!fill || isNaN(qty)) return;
      var pct = Math.max(4, Math.min(100, (qty / max) * 100));
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    });
  }

  /* ----------------------------------------------------------- Startup */
  function init() {
    initBackToTop();
    initAgeGate();
    initPromoPopup();
    initCountdowns();
    initBeforeAfter();
    initHotspots();
    initTabs();
    initSizeChart();
    initStickyAtc();
    recordRecentlyViewed();
    initRecentlyViewed();
    initQuickView();
    initLoadMore();
    initGiftWrap();
    initStockMeters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init pieces that live inside sections the theme editor re-renders
  document.addEventListener('shopify:section:load', function () {
    initCountdowns(); initBeforeAfter(); initHotspots(); initTabs(); initStockMeters(); initLoadMore();
  });
})();
